export enum StationStatusTitle {
  Online = 'Online',
  Offline = 'Offline',
  Healthy = 'Healthy',
  Unhealthy = 'Unhealthy',
}